// extracted by mini-css-extract-plugin
export default {"container":"bPW2WfPWm2Ih9i0DQ02z","round":"_FxRIEwmQdSpNT_5bzTJ","justified":"aTtAr6Enjr6yu1PJNf8p","elevation1":"fOs_PFqLsNUDjZv2shA3"};